import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders } from '@angular/common/http';
import { SourceDocumentIdentifier, DocumentIdentifier } from './document/document.model';
import { IndexFolderAction } from './data-entry/folder/data-entry-folder.model';
import { ArcAppAccessTypes } from './shared/application.model';
import { Utils } from './utils';

const API_VERSION_1 = 'api/v1/';
const NONE = "NONE";

/**
 *  If you add a new api please add to apiDefinitions below!!!
 */
export const api = {
  Auth: API_VERSION_1 + 'auth',
  Log: API_VERSION_1 + 'log',
  TemplatesRetrieval: API_VERSION_1 + 'templates/retrieval',
  TemplateRetrieval: API_VERSION_1 + 'template/retrieval',
  TemplateRetrievalCallback: API_VERSION_1 + 'template/retrieval/callback',
  TemplateRetrievalDocuments: API_VERSION_1 + 'template/retrieval/documents',
  TemplatesDataEntry: API_VERSION_1 + 'templates/dataentry',
  TemplateDataEntry: API_VERSION_1 + 'template/dataentry',
  TemplateDataEntryCallback: API_VERSION_1 + 'template/dataentry/callback',
  Document: API_VERSION_1 + 'document',
  DocumentDevices: API_VERSION_1 + 'document/devices',
  DocumentKeywords: API_VERSION_1 + 'document/keywords',
  DocumentRemarks: API_VERSION_1 + 'document/remarks',
  DocumentVersions: API_VERSION_1 + 'document/versions',
  DocumentVersion: API_VERSION_1 + 'document/version',
  DocumentLegalHold: API_VERSION_1 + 'document/legalhold',
  DocumentUnlock: API_VERSION_1 + 'document/unlock',
  DocumentIndex: API_VERSION_1 + 'document/index',
  DocumentFileInfo: API_VERSION_1 + 'document/files',
  DocumentSuffix: API_VERSION_1 + 'document/suffix',
  Documents: API_VERSION_1 + 'documents',
  DocumentstoIndex: API_VERSION_1 + 'documents/index',
  DocumentsToFetch: API_VERSION_1 + 'documents/tofetch',
  Folders: API_VERSION_1 + 'folders',
  ErrorFolders: API_VERSION_1 + 'errorfolders',
  FolderDocuments: API_VERSION_1 + 'folder/documents',
  FolderDocument: API_VERSION_1 + 'folder/document',
  IndexFolderDocument: API_VERSION_1 + 'folder/documents/index',
  Folder: API_VERSION_1 + 'folder',
  FolderDocumentFiles: API_VERSION_1 + 'folder/document/files',
  FolderDocumentCompId: API_VERSION_1 + 'folder/document/compId',
  TestFault: API_VERSION_1 + 'test/fault',
  DocumentSignedConfig: API_VERSION_1 + 'document/signedconfig',
  FolderDocumentFileUpload: API_VERSION_1 + 'folder/file',
  Users: API_VERSION_1 + 'users',
  Groups: API_VERSION_1 + 'groups',
  Applications: API_VERSION_1 + 'applications',
  Thumbnail: API_VERSION_1 + 'thumbnail',
  Route: API_VERSION_1 + 'route',
  Worksets: API_VERSION_1 + 'workflow/worksets',
  Workitems: API_VERSION_1 + 'workflow/workitems',
  WorkitemsBacklog: API_VERSION_1 + 'workflow/workitems/backlog',
  Worklist: API_VERSION_1 + 'workflow/worklist',
  Workitem: API_VERSION_1 + 'workflow/workitem',
  WorklistWorkitem: API_VERSION_1 + 'workflow/worklist/workitem',
  WorkflowForm: API_VERSION_1 + 'workflow/form',
  WorkitemHistory: API_VERSION_1 + 'workflow/workitem/history',
  Status: API_VERSION_1 + 'status',
};

export interface apidefinition {
  title: string,
  category: string,
  uri: string,
  method: string,
  description: string,
  params: string,
  paramsSample: string,
  payload: string,
  payloadSample: string,
  retCode: string,
  retPayload: string
};

export const apidefinitions: apidefinition[] = [
  { category: 'Authentication', title: 'Logon', uri: api.Auth, method: 'POST', description: 'Logon user to the File360 Server.', retCode: '', retPayload: '', params: '', payload: '{"name": "sysadmin", "password": "sysadmin", "culture": "en-US"}', paramsSample: NONE, payloadSample: '{"name": "sysadmin", "password": "sysadmin", "culture": "en-US"}' },
  { category: 'Authentication', title: 'Logoff', uri: api.Auth, method: 'DELETE', description: 'Logoff user from the File360 Server.', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Infratructure', title: 'Log', uri: api.Log, method: 'POST', description: 'Add a log message to the File360 Web Server log.', retCode: '', retPayload: '', params: '', payload: '{"UserName" : "User Name", "Message" : "Log Message"}', paramsSample: NONE, payloadSample: '{"UserName" : "User Name", "Message" : "Log Message"}' },
  { category: 'Infratructure', title: 'Status', uri: api.Status, method: 'GET', description: 'Get the Status of the web server.', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Infratructure', title: 'Test Server Fault Returns', uri: api.TestFault, method: 'GET', description: 'INTERNAL ONLY. Test the response for a particular server fault.', retCode: '', retPayload: '', params: '?servfault={servfault}', payload: '', paramsSample: '?servfault={servfault}', payloadSample: NONE },
  { category: 'Templates', title: 'Data Entry', uri: api.TemplatesDataEntry, method: 'GET', description: 'Get a list of data entry templates.', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Templates', title: 'Retrieval', uri: api.TemplatesRetrieval, method: 'GET', description: 'Get a list of retrieval templates.', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Template', title: 'Data Entry', uri: api.TemplateDataEntry, method: 'GET', description: 'Get a data entry template.', retCode: '', retPayload: '', params: '?id={id}', payload: '', paramsSample: '?id={id}', payloadSample: NONE },
  { category: 'Template', title: 'Data Entry Callback', uri: api.TemplateDataEntryCallback, method: 'POST', description: 'Data entry callback.', retCode: '', retPayload: '', params: '?callbackHandleId={id}&fieldId={fieldId}', payload: '', paramsSample: '?callbackHandleId={id}&fieldId={fieldId}', payloadSample: '{data entry template}' },
  { category: 'Template', title: 'Retrieval', uri: api.TemplateRetrieval, method: 'GET', description: 'Get a retrieval template.', retCode: '', retPayload: '', params: '?id={id}&applicationId={applicationId}', payload: '', paramsSample: '?id={id}&applicationId={applicationId}', payloadSample: NONE },
  { category: 'Template', title: 'Retrieval', uri: api.TemplateRetrievalDocuments, method: 'POST', description: 'Get a hit list. No input fields(no search criteria) and default output fields', retCode: '', retPayload: '', params: '', payload: '{"Id":2,"InputFields":[],"OutputFields":[], "MaxHits":100,"IncludeExpiredDocuments":false,"OnlyLegalHoldDocuments":false,"AppendResults":false}', paramsSample: NONE, payloadSample: '{"Id":2,"InputFields":[],"OutputFields":[], "MaxHits":100,"IncludeExpiredDocuments":false,"OnlyLegalHoldDocuments":false,"AppendResults":false}' },
  { category: 'Template', title: 'Retrieval', uri: api.TemplateRetrievalDocuments, method: 'POST', description: 'Get a hit list. One input field and 1 output field.', retCode: '', retPayload: '', params: '', payload: '{"Id": 1,"InputFields": [{"Key": "Order #","Value": {"Id": 1001,"Name": "Order #","ApplicationArchivePairs":[{"ApplicationId":1,"ApplicationName":"","ArchiveId":1,"ArchiveName":""}],"Alignment": 0,"Display": 0,"DisplayType": "E","FieldType": 6,"FillCharacter": " ","Hint": "Order #","Length": 10,"Mask": "","MaskFormat": 0,"MaskPlaceholder": "_","MaskStorage": 5,"Precision": 0,"CanCompare": true,"ChangeCallback": {},"CompareOperator": 1,"ComparePosition1": {},"ComparePosition2": {},"Conjunction": 0,"ConjunctionPosition": {},"EntryCallback": {},"ExitCallback": {},"Field1Position": {},"Field2Position": {},"Label": "Order #","LabelPosition": {},"LeftParenthesis": false,"LeftParenthesisPosition": {},"LookupTable": null,"Required": false,"RightParenthesis": false,"RightParenthesisPosition": {},"Value1": "*","Value2": null}}],"OutputFields": [{"Key": "Order #","Value": {"Id": 1001,"Name": "Order #","ApplicationArchivePairs": [{"ApplicationId":1,"ApplicationName":"","ArchiveId":1,"ArchiveName":""}],"CanSort": true,"CharacterLength": 10,"DisplayType": "E","FieldType": 6,"IncludeInOutput": true,"IsSystemField": false,"Label": "Order #","Mask": "","OutputFieldWidth": 0,"OutputOrder": 0,"Precision": 0,"SortOrder": 0,"SortType": 2}}]}', paramsSample: NONE, payloadSample: '{"Id": 1,"InputFields": [{"Key": "Order #","Value": {"Id": 1001,"Name": "Order #","Alignment": 0,"Display": 0,"DisplayType": "E","FieldType": 6,"FillCharacter": " ","Hint": "Order #","Length": 10,"Mask": "","MaskFormat": 0,"MaskPlaceholder": "_","MaskStorage": 5,"Precision": 0,"CanCompare": true,"ChangeCallback": {},"CompareOperator": 1,"ComparePosition1": {},"ComparePosition2": {},"Conjunction": 0,"ConjunctionPosition": {},"EntryCallback": {},"ExitCallback": {},"Field1Position": {},"Field2Position": {},"Label": "Order #","LabelPosition": {},"LeftParenthesis": false,"LeftParenthesisPosition": {},"LookupTable": null,"Required": false,"RightParenthesis": false,"RightParenthesisPosition": {},"Value1": "1*","Value2": null}}],"OutputFields": [{"Key": "Order #","Value": {"Id": 1001,"Name": "Order #","ApplicationArchivePairs": [{"ApplicationId":1,"ApplicationName":"","ArchiveId":1,"ArchiveName":""}],"CanSort": true,"CharacterLength": 10,"DisplayType": "E","FieldType": 6,"IncludeInOutput": true,"IsSystemField": false,"Label": "Order #","Mask": "","OutputFieldWidth": 0,"OutputOrder": 0,"Precision": 0,"SortOrder": 0,"SortType": 2}}]}' },
  { category: 'Template', title: 'Retrieval Callback', uri: api.TemplateRetrievalCallback, method: 'POST', description: 'Retieval template callback.', retCode: '', retPayload: '', params: '?callbackHandleId={id}&fieldId={fieldId}', payload: '', paramsSample: '?callbackHandleId={id}&fieldId={fieldId}', payloadSample: '{retrieval template}' },
  { category: 'Documents', title: 'Fetch', uri: api.DocumentsToFetch, method: 'POST', description: 'INTERNAL ONLY. Get a set of documents.', retCode: '', retPayload: '', params: '', payload: '{"DocumentsToFetch":[{"MasterId":49,"Version":1,"KeyfileDocId":"","ContentServerId":""}],"PackageFiles":0,"ApplyAnnotations":false,"RenderAsUserId":0,"RenderAsGroupId":0,"IsEditingSourceFiles":false,"IsEmailing":false,"IsPrinting":false}', paramsSample: NONE, payloadSample: '{"DocumentsToFetch":[{"MasterId":49,"Version":1,"KeyfileDocId":"","ContentServerId":""}],"PackageFiles":0,"ApplyAnnotations":false,"RenderAsUserId":0,"RenderAsGroupId":0,"IsEditingSourceFiles":false,"IsEmailing":false,"IsPrinting":false}' },
  { category: 'Documents', title: 'Index', uri: api.DocumentstoIndex, method: 'PUT', description: 'Index a set of documents. Sample updates 1 DMV document index information. Change masterId, version and value appropriately', retCode: '', retPayload: '', params: '', payload: '{"EntryTemplate": {"Id": 3,"Name": "DMV","ApplicationId": 3,"ApplicationName": "DMV","ArchiveId": 1,"ArchiveName": "ARC01","AvailableDevices": [{"DeviceType": 1,"Id": 1,"Name": "Cache1"}],"CanDataEnter": true,"CanUpdate": true,"EntryCallback": {},"ExitCallback": {},"InputFields": [{"Key": 1015,"Value": {"Id": 1015,"Name": "Last Name","Alignment": 0,"Display": 0,"DisplayType": "E","FieldType": 6,"FillCharacter": " ","Hint": "Last Name","Length": 30,"Mask": "","MaskFormat": 0,"MaskPlaceholder": "_","MaskStorage": 5,"Precision": 0,"ChangeCallback": {},"EntryCallback": {},"ExitCallback": {},"FieldPosition": {},"IsDuplicate": false,"Label": "Last Name","LabelPosition": {},"LookupTable": null,"MappingNumber": 1,"OutlookMailMappingPath": "","Required": false,"RestrictedCharacters": null,"Value": "Jones"}}],"SelectedDevice": {"DeviceType": 1,"Id": 1,"Name": "Cache1"}},"Document": {"MasterId": 0,"Version": 0,"KeyfileDocId": "","ContentServerId": "","VersionLabel": "","VersionCreatorId": 0,"VersionCreatorName": "","AnnotationCount": 0,"Suffix": 0},"Documents": [{"MasterId": 74,"Version": 1,"KeyfileDocId": "","ContentServerId": "","VersionLabel": "","VersionCreatorId": 0,"VersionCreatorName": "","AnnotationCount": 0,"Suffix": 0}]}', paramsSample: NONE, payloadSample: '{"EntryTemplate": {"Id": 3,"Name": "DMV","ApplicationId": 3,"ApplicationName": "DMV","ArchiveId": 1,"ArchiveName": "ARC01","AvailableDevices": [{"DeviceType": 1,"Id": 1,"Name": "Cache1"}],"CanDataEnter": true,"CanUpdate": true,"EntryCallback": {},"ExitCallback": {},"InputFields": [{"Key": 1015,"Value": {"Id": 1015,"Name": "Last Name","Alignment": 0,"Display": 0,"DisplayType": "E","FieldType": 6,"FillCharacter": " ","Hint": "Last Name","Length": 30,"Mask": "","MaskFormat": 0,"MaskPlaceholder": "_","MaskStorage": 5,"Precision": 0,"ChangeCallback": {},"EntryCallback": {},"ExitCallback": {},"FieldPosition": {},"IsDuplicate": false,"Label": "Last Name","LabelPosition": {},"LookupTable": null,"MappingNumber": 1,"OutlookMailMappingPath": "","Required": false,"RestrictedCharacters": null,"Value": "Jones"}}],"SelectedDevice": {"DeviceType": 1,"Id": 1,"Name": "Cache1"}},"Document": {"MasterId": 0,"Version": 0,"KeyfileDocId": "","ContentServerId": "","VersionLabel": "","VersionCreatorId": 0,"VersionCreatorName": "","AnnotationCount": 0,"Suffix": 0},"Documents": [{"MasterId": 74,"Version": 1,"KeyfileDocId": "","ContentServerId": "","VersionLabel": "","VersionCreatorId": 0,"VersionCreatorName": "","AnnotationCount": 0,"Suffix": 0}]}' },
  { category: 'Document', title: 'Destroy', uri: api.Document, method: 'DELETE', description: ' Destroy document.', retCode: '', retPayload: '', params: '?masterId={masterId}&version={version}&allversions={allversions}&priorversions={priorversions}', payload: '', paramsSample: '?masterId={masterId}&version={version}&allversions={allversions}&priorversions={priorversions}', payloadSample: NONE },
  { category: 'Document', title: 'Devices', uri: api.DocumentDevices, method: 'GET', description: 'Get devices for a document.', retCode: '', retPayload: '', params: '?masterId={masterId}&version={version}', payload: '', paramsSample: '?masterId={masterId}&version={version}', payloadSample: NONE },
  { category: 'Document', title: 'Index', uri: api.DocumentIndex, method: 'GET', description: 'Get document index data.', retCode: '', retPayload: '', params: '?indexAction={indexAction}&masterId={masterId}&version={version}&suffix={suffix}', payload: '', paramsSample: '?indexAction={indexAction}&masterId={masterId}&version={version}&suffix={suffix}', payloadSample: NONE },
  { category: 'Document', title: 'Index', uri: api.DocumentIndex, method: 'PUT', description: 'Update a document index data.', retCode: '', retPayload: '', params: '?masterId={masterId}&version={version}&suffix={suffix}', payload: '{"Id":1,"Name":"Accounts payable","ApplicationId":1,"ApplicationName":"Accounts payable","ArchiveId":1,"ArchiveName":"ARC01","InputFields":[{"Key":1001,"Value":{"Id":1001,"Name":"Order #","Value":"Suffix-1"}}}],"SelectedDevice":{"DeviceType":1,"Id":1,"Name":"Cache1"}}', paramsSample: '?masterId={masterId}&version={version}&suffix={suffix}', payloadSample: '{"Id":1,"Name":"Accounts payable","ApplicationId":1,"ApplicationName":"Accounts payable","ArchiveId":1,"ArchiveName":"ARC01","InputFields":[{"Key":1001,"Value":{"Id":1001,"Name":"Order #","Value":"Suffix-1"}}}],"SelectedDevice":{"DeviceType":1,"Id":1,"Name":"Cache1"}}' },
  { category: 'Document', title: 'Index', uri: api.DocumentIndex, method: 'DELETE', description: 'Delete a document index.', retCode: '', retPayload: '', params: '?masterId={masterId}&version={version}&suffix={suffix}', payload: '', paramsSample: '?masterId={masterId}&version={version}&suffix={suffix}', payloadSample: NONE },
  { category: 'Document', title: 'Index', uri: api.DocumentIndex, method: 'POST', description: 'Index a document.', retCode: '', retPayload: '', params: '?indexDataId={indexDataId}&action={action}', payload: 'Please see the following knowledge base article for details on how to index a document : https://knowledge.opentext.com/knowledge/cs.dll/kcs/kbarticle/view/KB13512080', paramsSample: '?indexDataId={indexDataId}&action={action}', payloadSample: 'Please see the following knowledge base article for details on how to index a document : https://knowledge.opentext.com/knowledge/cs.dll/kcs/kbarticle/view/KB13512080' },
  { category: 'Document', title: 'Keywords', uri: api.DocumentKeywords, method: 'GET', description: 'Get the keywords for a document.', retCode: '', retPayload: '', params: '?masterId={id}', payload: '', paramsSample: '?masterId={id}', payloadSample: NONE },
  { category: 'Document', title: 'Keywords', uri: api.DocumentKeywords, method: 'POST', description: 'Create/Update the keywords for a document.', retCode: '', retPayload: '', params: '', payload: '{"Document":{"AnnotationCount":0,"ContentServerId":null,"KeyfileDocId":null,"MasterId":37,"Version":1,"VersionCreated":null,"VersionCreatorId":0,"VersionCreatorName":null,"VersionLabel":null},"KeywordData":"abcd efgh ijkl","AllowAdds":true}', paramsSample: NONE, payloadSample: '{"Document":{"AnnotationCount":0,"ContentServerId":null,"KeyfileDocId":null,"MasterId":37,"Version":1,"VersionCreated":null,"VersionCreatorId":0,"VersionCreatorName":null,"VersionLabel":null},"KeywordData":"abcd efgh ijkl","AllowAdds":true}' },
  { category: 'Document', title: 'Legal Hold', uri: api.DocumentLegalHold, method: 'GET', description: 'Get legal hold.', retCode: '', retPayload: '', params: '?masterId={masterId}', payload: '', paramsSample: '?masterId={masterId}&version={version}', payloadSample: NONE },
  { category: 'Document', title: 'Legal Hold', uri: api.DocumentLegalHold, method: 'POST', description: 'Set legal hold.', retCode: '', retPayload: '', params: '?masterId={masterId}&version={version}', payload: '{"HoldReason":"abcd efgh","HoldCreated":null,"HoldExpires":"/Date(1574312400000-0500)/","HoldExpiresDate":"2019-11-21T05:00:00.000Z","HoldUserCreated":{"Id":0,"Name":""}}', paramsSample: '?masterId={masterId}&version={version}', payloadSample: '{"HoldReason":"abcd efgh","HoldCreated":null,"HoldExpires":"/Date(1574312400000-0500)/","HoldExpiresDate":"2019-11-21T05:00:00.000Z","HoldUserCreated":{"Id":0,"Name":""}}' },
  { category: 'Document', title: 'Legal Hold', uri: api.DocumentLegalHold, method: 'DELETE', description: 'Remove legal hold.', retCode: '', retPayload: '', params: '?masterId={masterId}', payload: '', paramsSample: '?masterId={masterId}&version={version}', payloadSample: NONE },
  { category: 'Document', title: 'Remarks', uri: api.DocumentRemarks, method: 'GET', description: 'Get the remarks for a document.', retCode: '', retPayload: '', params: '?masterId={id}&suffix={suffix}', payload: '', paramsSample: '?masterId={id}&suffix={suffix}', payloadSample: NONE },
  { category: 'Document', title: 'Remarks', uri: api.DocumentRemarks, method: 'POST', description: 'Create/Update the remarks for a document.', retCode: '', retPayload: '', params: '', payload: '{"DocumentIdentifier":{"ContentServerId":null,"KeyfileDocId":null,"MasterId":45,"Version":1,"ExpirationDate":null,"LastModified":"/Date(-62135578800000-0500)/","Suffix":0},"Content":"i dont like mondays","AllowAdds":true}', paramsSample: NONE, payloadSample: '{"DocumentIdentifier":{"ContentServerId":null,"KeyfileDocId":null,"MasterId":45,"Version":1,"ExpirationDate":null,"LastModified":"/Date(-62135578800000-0500)/","Suffix":0},"Content":"i dont like mondays","AllowAdds":true}' },
  { category: 'Document', title: 'Suffix', uri: api.DocumentSuffix, method: 'POST', description: 'Post document suffix index data.', retCode: '', retPayload: '', params: '?masterId={masterId}&version={version}', payload: '{"Id":1,"Name":"Accounts payable","ApplicationId":1,"ApplicationName":"Accounts payable","ArchiveId":1,"ArchiveName":"ARC01","InputFields":[{"Key":1001,"Value":{"Id":1001,"Name":"Order #","Value":"67412"}},{"Key":1002,"Value":{"Id":1002,"Name":"PO #","Value":"1356790"}}],"SelectedDevice":{"DeviceType":1,"Id":1,"Name":"Cache1"}}', paramsSample: '?masterId={masterId}&version={version}', payloadSample: '{"Id":1,"Name":"Accounts payable","ApplicationId":1,"ApplicationName":"Accounts payable","ArchiveId":1,"ArchiveName":"ARC01","InputFields":[{"Key":1001,"Value":{"Id":1001,"Name":"Order #","Value":"67412"}},{"Key":1002,"Value":{"Id":1002,"Name":"PO #","Value":"1356790"}}],"SelectedDevice":{"DeviceType":1,"Id":1,"Name":"Cache1"}}' },
  { category: 'Document', title: 'Files Information', uri: api.DocumentFileInfo, method: 'GET', description: 'Get document files information. Including source and thumbnail file locations.', retCode: '', retPayload: '', params: '?masterId={masterId}&version={version}', payload: '', paramsSample: '?masterId={masterId}&version={version}', payloadSample: NONE },
  { category: 'Document', title: 'Unlock', uri: api.DocumentUnlock, method: 'DELETE', description: 'Unlock document.', retCode: '', retPayload: '', params: '?masterId={masterId}', payload: '', paramsSample: '?masterId={masterId}', payloadSample: NONE },
  { category: 'Document', title: 'Versions', uri: api.DocumentVersions, method: 'GET', description: 'Get the versions for a document.', retCode: '', retPayload: '', params: '?masterId={id}', payload: '', paramsSample: '?masterId={id}', payloadSample: NONE },
  { category: 'Document', title: 'Version', uri: api.DocumentVersion, method: 'POST', description: 'Create an new version of the document.', retCode: '', retPayload: '', params: '?masterId={masterId}&versionLabel={versionLabel}&deviceId={deviceId}', payload: '[{"fileNumber":1,"filePath":"relative/path/from/File360 Web/fileName1.ext"},{"fileNumber":2,"filePath":"relative/path/from/File360 Web/fileName2.ext"},{"fileNumber":3,"filePath":"relative/path/from/File360 Web/fileName3.ext"}]', paramsSample: '?masterId={masterId}&versionLabel={versionLabel}&deviceId={deviceId}', payloadSample: '[{"fileNumber":1,"filePath":"relative/path/from/File360 Web/fileName1.ext"},{"fileNumber":2,"filePath":"relative/path/from/File360 Web/fileName2.ext"},{"fileNumber":3,"filePath":"relative/path/from/File360 Web/fileName3.ext"}]' },
  { category: 'Folders', title: 'Folders', uri: api.Folders, method: 'GET', description: 'Get a list of index folders.', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Folders', title: 'Error Folders', uri: api.ErrorFolders, method: 'GET', description: 'Get a list of index error folders.', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Folders', title: 'Folder', uri: api.Folder, method: 'PUT', description: 'Update a folder.', retCode: '', retPayload: '', params: '?action={action}', payload: '{"ApplicationId":1,"ApplicationName":"Accounts payable","ArchiveId":1,"ArchiveName":"ARC01","AssignedToGroupId":0,"AssignedToName":"sysadmin","AssignedToUserId":1001,"Count":10,"Created":"/Date(1543355676740-0500)/","Id":8,"IsError":false,"Name":"MyFolderName","TypeOfFolder":1,"UsedBy":"","UsedById":0}', paramsSample: '?action={action}', payloadSample: '{"ApplicationId":1,"ApplicationName":"Accounts payable","ArchiveId":1,"ArchiveName":"ARC01","AssignedToGroupId":0,"AssignedToName":"sysadmin","AssignedToUserId":1001,"Count":10,"Created":"/Date(1543355676740-0500)/","Id":8,"IsError":false,"Name":"MyFolderName","TypeOfFolder":1,"UsedBy":"","UsedById":0}' },
  { category: 'Folders', title: 'Folder', uri: api.Folder, method: 'DELETE', description: 'Delete a folder.', retCode: '', retPayload: '', params: '?folderId={folderId}', payload: '', paramsSample: '?folderId={folderId}', payloadSample: NONE },
  { category: 'Folders', title: 'Folder Documents', uri: api.FolderDocuments, method: 'GET', description: 'Get a list of documents belonging to a folder.', retCode: '', retPayload: '', params: '?id={id}', payload: '', paramsSample: '?id={id}', payloadSample: NONE },
  { category: 'Folders', title: 'Folder Document', uri: api.FolderDocument, method: 'POST', description: 'Create a document in the user folder.', retCode: '', retPayload: '', params: '?sessionName={sessionName}&archiveid={archiveid}&applicationid={applicationid}', payload: '', paramsSample: '?sessionName={sessionName}&archiveid={archiveid}&applicationid={applicationid}', payloadSample: NONE },
  { category: 'Folders', title: 'Folder Document', uri: api.FolderDocument, method: 'DELETE', description: 'Delete a document in the folder.', retCode: '', retPayload: '', params: '?indexDataId={indexDataId}', payload: '', paramsSample: '?indexDataId={indexDataId}', payloadSample: NONE },
  { category: 'Folders', title: 'Folder Document to view', uri: api.FolderDocument, method: 'GET', description: 'Send first available folder document to Brava.', retCode: '', retPayload: '', params: '?folderId={folderId}&id={id}&prevDoc={prevDoc}&nextDoc={nextDoc}&isFolderShared={isFolderShared}', payload: '', paramsSample: '?folderId={folderId}&id={id}&prevDoc={prevDoc}&nextDoc={nextDoc}&isFolderShared={isFolderShared}', payloadSample: NONE },
  { category: 'Folders', title: 'Folder Document File Information', uri: api.FolderDocumentFiles, method: 'GET', description: 'Get the file information for a folder document .', retCode: '', retPayload: '', params: '?indexId={indexId}&isFolderShared={isFolderShared}', payload: '', paramsSample: '', payloadSample: NONE },
  { category: 'Folders', title: 'Folder Document CompId', uri: api.FolderDocumentCompId, method: 'GET', description: 'Get the Brava composition ID for a folder document .', retCode: '', retPayload: '', params: '', payload: '[{"filePath":"documents/downloads/1/af6cc100-85db-4d6d-8512-70f7a5724d50/44/00000001.tif"},{"filePath":"documents/downloads/1/af6cc100-85db-4d6d-8512-70f7a5724d50/44/00000002.tif"},{"filePath":"documents/uploads/1/af6cc100-85db-4d6d-8512-70f7a5724d50/2020_01_03_13_21_43_45/3.tif"}]', paramsSample: '', payloadSample: '[{"filePath":"documents/downloads/1/af6cc100-85db-4d6d-8512-70f7a5724d50/44/00000001.tif"},{"filePath":"documents/downloads/1/af6cc100-85db-4d6d-8512-70f7a5724d50/44/00000002.tif"},{"filePath":"documents/uploads/1/af6cc100-85db-4d6d-8512-70f7a5724d50/2020_01_03_13_21_43_45/3.tif"}]' },
  { category: 'Viewer', title: 'Signed Config', uri: api.DocumentSignedConfig, method: 'GET', description: 'Get the Brava signed configuration for viewing a document.', retCode: '', retPayload: '', params: '?beservid={beservid}&compid={compid}&uivariant={uivariant}&filecount={filecount}&clientid={clientid}', payload: '', paramsSample: '?beservid={beservid}&compid={compid}&uivariant={uivariant}&filecount={filecount}&clientid={clientid}', payloadSample: NONE },
  { category: 'User/Group', title: 'Groups', uri: api.Groups, method: 'GET', description: 'Get a list of groups.', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'User/Group', title: 'Users', uri: api.Users, method: 'GET', description: 'Get a list of users.', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Applications', title: 'Application', uri: api.Applications, method: 'GET', description: 'Get a list of archives and their applications with the given access type.', retCode: '', retPayload: '', params: '?accessType={accessType}', payload: '', paramsSample: '?accessType={accessType}', payloadSample: NONE },
  { category: 'Route', title: 'Route', uri: api.Route, method: 'POST', description: 'Send to a user and/or group.', retCode: '', retPayload: '', params: '?title={title}&comment={comment}&templateId={templateId}', payload: '{"documents":[{"MasterId":410,"Version":1,"KeyfileDocId":"","ContentServerId":"","VersionLabel":"","VersionCreatorId":0,"VersionCreatorName":"","AnnotationCount":0,"Suffix":0}],"users":[1],"groups":[]}', paramsSample: '?title={title}&comment={comment}&templateId={templateId}', payloadSample: '{"documents":[{"MasterId":410,"Version":1,"KeyfileDocId":"","ContentServerId":"","VersionLabel":"","VersionCreatorId":0,"VersionCreatorName":"","AnnotationCount":0,"Suffix":0}],"users":[1],"groups":[]}' },
  { category: 'Workflow', title: 'Worksets', uri: api.Worksets, method: 'GET', description: 'Get a list of worksets', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Workflow', title: 'Workitems', uri: api.Workitems, method: 'GET', description: 'Get a list of workitems in a workset', retCode: '', retPayload: '', params: '?workflowId={workflowId}&workset={worksetName}', payload: '', paramsSample: 'workflowId={workflowId}&workset={worksetName}', payloadSample: NONE },
  { category: 'Workflow', title: 'Workitems', uri: api.Workitems, method: 'GET', description: 'Get a count of backlogged workitems', retCode: '', retPayload: '', params: '', payload: '', paramsSample: '', payloadSample: NONE },
  { category: 'Workflow', title: 'Worklist', uri: api.Worklist, method: 'GET', description: 'Get a list of workitems reserved', retCode: '', retPayload: '', params: '', payload: '', paramsSample: NONE, payloadSample: NONE },
  { category: 'Workflow', title: 'Workitem', uri: api.Worklist, method: 'GET', description: 'Get a workitem and reserve it', retCode: '', retPayload: '', params: '?workitemId={workitemId}&type={type}&workstep={workstep}&workset={workset}&workflowId={workflowId}&timestamp={timestamp}', payload: '', paramsSample: '?workitemId={workitemId}&type={type}&workstep={workstep}&workset={workset}&workflowId={workflowId}&timestamp={timestamp}', payloadSample: NONE },
  { category: 'Workflow', title: 'Workitem History', uri: api.Worklist, method: 'GET', description: 'Get a workitem history', retCode: '', retPayload: '', params: '?workitemId={workitemId}', payload: '', paramsSample: '?workitemId={workitemId}', payloadSample: NONE },
  { category: 'Workflow', title: 'Workitem', uri: api.Worklist, method: 'PUT', description: 'Save a workitem', retCode: '', retPayload: '', params: '', payload: '', paramsSample: '', payloadSample: NONE },
  { category: 'Workflow', title: 'Workitem', uri: api.Worklist, method: 'POST', description: 'Send a workitem', retCode: '', retPayload: '', params: '', payload: '', paramsSample: '', payloadSample: NONE },
  { category: 'Workflow', title: 'Worklist Workitem', uri: api.Worklist, method: 'DELETE', description: 'Delete a workitem from the worklist', retCode: '', retPayload: '', params: '?workitemId={workitemId}', payload: '', paramsSample: '?workitemId={workitemId}', payloadSample: NONE },
  { category: 'Workflow', title: 'Form', uri: api.WorkflowForm, method: 'GET', description: 'Get a workflow form', retCode: '', retPayload: '', params: '?className={className}', payload: '', paramsSample: '?className={className}', payloadSample: NONE }
];

@Injectable({
  providedIn: 'root',
})
export class CommandService {

  public static NONE = NONE;
  private headers(userId: string) { return new HttpHeaders() };

  constructor() { }

  /**
   * getUrl
   * @param api url part 
   */
  getUrl(api: string) {
    return `File360RESTService.svc/${api}`;
  }

  /**
   * logOnOptions
   */
  logOnOptions() {
    return {
      params: new HttpParams(),
      headers: this.headers("")
    };
  }

  /**
   * logOffOptions
   * @param sessionId Unique user session id
   */
  logOffOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getRetrievalTemplatesOptions
   * @param sessionId Unique user session id
   */
  getRetrievalTemplatesOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDataEntryTemplatesOptions
   * @param sessionId  Unique user session id
   */
  getDataEntryTemplatesOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getRetrievalTemplateOptions
   * @param sessionId Unique user session id
   * @param id Template id
   * @param applicationId Application id
   */
  getRetrievalTemplateOptions(sessionId: string, id: number, applicationId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('id', id.toString())
        .append('applicationId', applicationId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDataEntryTemplateOptions
   * @param sessionId Unique user session id
   * @param id Template id
   */
  getDataEntryTemplateOptions(sessionId: string, id: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('id', id.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * runCallbackRetrievalOptions
   * @param sessionId Unique user session id
   * @param handleId Callback handle
   * @param fieldId Field id
   */
  runCallbackRetrievalOptions(sessionId: string, handleId: number, fieldId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('callbackHandleId', handleId.toString())
        .append('fieldId', fieldId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * runCallbackDataEntryOptions
   * @param sessionId Unique user session id
   * @param handleId Callback handle
   * @param fieldId Field id
   */
  runCallbackDataEntryOptions(sessionId: string, handleId: number, fieldId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('callbackHandleId', handleId.toString())
        .append('fieldId', fieldId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * performRetrievalOptions
   * @param sessionId Unique user session id
   */
  performRetrievalOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /**
   * fetchDocumentsOptions
   * @param sessionId Unique user session id
   */
  fetchDocumentsOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /** retrieveKeywordsOptions
  * @param sessionId sessionId for the user
  * @param document DocumentIdentifier
  */
  retrieveKeywordsOptions(sessionId: string, document: SourceDocumentIdentifier) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', document.MasterId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /** updateKeywordsOptions
   * @param sessionId sessionId for the user
   */
  updateKeywordsOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /** retrieveRemarksOptions
     * @param sessionId sessionId for the user
     * @param document DocumentIdentifier
     */
  retrieveRemarksOptions(sessionId: string, document: DocumentIdentifier) {
    return {
      // Add safe, URL encoded parameters and headers
      params: new HttpParams()
        .append('masterId', document.MasterId.toString())
        .append('suffix', document.Suffix.toString()),
      headers: this.headers(sessionId)
    };
  }

  /** updateRemarksOptions
   * @param sessionId sessionId for the user
   */
  updateRemarkOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /**
   * deleteDocumentOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id
   * @param version Version id 
   * @param suffix Suffix id
   */
  deleteDocumentOptions(sessionId: string, masterId: number, version: number, suffix: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString())
        .append('version', version.toString())
        .append('suffix', suffix.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * destroyDocumentsOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id
   * @param version Version id
   * @param suffix Suffix id
   * @param allVersions destroy all version boolean
   * @param priorVersions destroy all prior versions boolean
   */
  destroyDocumentsOptions(sessionId: string, masterId: number, version: number, suffix: number, allVersions: boolean, priorVersions: boolean) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString())
        .append('version', version.toString())
        .append('suffix', suffix.toString())
        .append('allversions', allVersions.toString())
        .append('priorversions', priorVersions.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDataEntryFoldersOptions
   * @param sessionId sessionId for the user
   */
  getDataEntryFoldersOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDataEntryErrorFoldersOptions
   * @param sessionId sessionId for the user
   */
  getDataEntryErrorFoldersOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }


  /**
   * getDataEntryFolderDocumentsOptions
   * @param sessionId sessionId for the user
   * @param folderId folderId for which to get a list of documents
   */
  getDataEntryFolderDocumentsOptions(sessionId: string, folderId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('id', folderId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDataEntryFolderDocumentsOptions
   * @param sessionId sessionId for the user
   * @param folderId folderId for which to get document
   * @param documentId the document Id if selected from folder list
   * @param prevDoc is true if the previous document button is used
   * @param nextDoc is true if the next document button is used
   * @param isFolderShared isFolderShared for use with others
   */
  viewDataEntryFolderDocumentOptions(sessionId: string, folderId: number, documentId: number, prevDoc: boolean, nextDoc: boolean, isFolderShared: boolean) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('folderId', folderId.toString())
        .append('id', documentId.toString())
        .append('prevDoc', prevDoc.toString())
        .append('nextDoc', nextDoc.toString())
        .append('isFolderShared', isFolderShared.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getCreateFolderDocumentOptions
   * @param sessionId sessionId for the user
   * @param sessionName session name
   * @param archiveId archive id
   * @param applicationId applicaiton id
   */
  getCreateFolderDocumentOptions(sessionId: string, sessionName: string, archiveId: number, applicationId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('sessionName', sessionName.trim())
        .append('archiveId', archiveId.toString())
        .append('applicationId', applicationId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDeleteFolderDocumentOptions
   * @param sessionId sessionId for the user
   * @param folderDocumentIndexId id of document in the folder
   */
  getDeleteFolderDocumentOptions(sessionId: string, folderDocumentIndexId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('indexDataId', folderDocumentIndexId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getUsersOptions
   * @param sessionId sessionId for the user
   */
  getUsersOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getGroupsOptions
   * @param sessionId sessionId for the user
   */
  getGroupsOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getUpdateFolderOptions
   * @param sessionId sessionId for the user
   * @param action action to perform on folder
   */
  getUpdateFolderOptions(sessionId: string, action: IndexFolderAction) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('action', action.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDeleteFolderOptions
   * @param sessionId sessionId for the user
   * @param folderId Folder id
   */
  getDeleteFolderOptions(sessionId: string, folderId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('folderId', folderId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getApplicationsOptions 
   * @param sessionId sessionId for the user
   * @param accessType Application type
   */
  getApplicationsOptions(sessionId: string, accessType: ArcAppAccessTypes) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('accessType', accessType.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDocumentVersionsOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id
   */
  getDocumentVersionsOptions(sessionId: string, masterId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getLegalHoldOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id of which to set the legal hold
   * @param version Version id of which to set the legal hold
   */
  setLegalHoldOptions(sessionId: string, masterId: number, version: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString())
        .append('version', version.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * removeLegalHoldOptions
   * @param sessionId sessionId for the user
   * @param masterId masterId of which to remove the legal hold
   */
  removeLegalHoldOptions(sessionId: string, masterId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getUnlockOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id
   * @param version Version id
   */
  getUnlockOptions(sessionId: string, masterId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getfetchDocumentIndexOptions
   * @param sessionId sessionId for the user
   * @param indexAction Indexing action (index, index first, suffix etc)
   * @param masterId Master id
   * @param version Version id
   * @param suffix Suffix id
   */
  getfetchDocumentIndexOptions(sessionId: string, indexAction: number, masterId: number, version: number, suffix: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('indexAction', indexAction.toString())
        .append('masterId', masterId.toString())
        .append('version', version.toString())
        .append('suffix', suffix.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getSuffixDocumentOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id
   * @param version Version id
   * @param suffix Suffix id
   */
  getSuffixDocumentOptions(sessionId: string, masterId: number, version: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString())
        .append('version', version.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getIndexDocumentsOptions
   * @param sessionId sessionId for the user
   */
  getIndexDocumentsOptions(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams(),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDocumentFileOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id
   * @param version Version id
   */
  getDocumentFileInfoOptions(sessionId: string, masterId: number, version: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString())
        .append('version', version.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDocumentDevicesOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id
   * @param version Version id
   */
  getDocumentDevicesOptions(sessionId: string, masterId: number, version: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString())
        .append('version', version.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getFolderDocumentFileOptions
   * @param sessionId sessionId for the user
   * @param indexId Thumbnail index number
   * @param isFolderShared Is folder shared
   */
  getFolderDocumentFileOptions(sessionId: string, indexId: number, isFolderShared: boolean) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('indexId', indexId.toString())
        .append('isFolderShared', isFolderShared.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDocumentNewVersionOptions
   * @param sessionId sessionId for the user
   * @param masterId Master id
   * @param versionLabel Version label
   * @param deviceId Device id
   */
  getDocumentNewVersionOptions(sessionId: string, masterId: number, versionLabel: string, deviceId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('masterId', masterId.toString())
        .append('versionLabel', versionLabel)
        .append('deviceId', deviceId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getSendDocumentsToUserOrGroupOptions
   * @param sessionId sessionId for the user
   * @param title Route title
   * @param comment Route comment
   * @param templateId Template id
   */
  getSendDocumentsToUserOrGroupOptions(sessionId: string, title: string, comment: string, templateId: number) {
    // Add safe, URL encoded parameters and headers
    return {
      params: new HttpParams()
        .append('title', title)
        .append('comment', comment)
        .append('templateId', templateId.toString()),
      headers: this.headers(sessionId)
    };
  }

  /**
   * getDocumentCreateOptions
   * @param sessionId sessionId for the user
   * @param indexDataId Id of document in folder 
   * @param action Action id to perform
   */
  getDocumentCreateOptions(sessionId: string, indexDataId: number, action: number) {
    return {
      // Add safe, URL encoded parameters and headers
      params: new HttpParams()
        .append('indexDataId', indexDataId.toString())
        .append('action', action.toString()),
      headers: this.headers(sessionId)
    };
  }

  getWorkitemsOptions(sessionId: string, workflowId: number, workset: string) {
    return {
      // Add safe, URL encoded parameters and headers
      params: new HttpParams()
        .append('workflowId', workflowId.toString())
        .append('workset', workset),
      headers: this.headers(sessionId)
    };
  }

  getHeader(sessionId: string) {
    // Add safe, URL encoded parameters and headers
    return {
      headers: this.headers(sessionId)
    };
  }

  getWorkitemOptions(sessionId: string, workitemId: string, type: number, workstep: string, workset: string, workflowId: number, timestamp: Date | null) {
    return {
      // Add safe, URL encoded parameters and headers
      params: new HttpParams()
        .append('workitemId', workitemId)
        .append('type', type.toString())
        .append('workstep', workstep)
        .append('workset', workset)
        .append('workflowId', workflowId.toString())
        .append('timestamp', Utils.getDateToGet(timestamp)),
      headers: this.headers(sessionId)
    };
  }

  getWorklistWorkitemOptions(sessionId: string, workitemId: string) {
    return {
      // Add safe, URL encoded parameters and headers
      params: new HttpParams()
        .append('workitemId', workitemId),
      headers: this.headers(sessionId)
    };
  }

  getWorkitemHistoryOptions(sessionId: string, workitemId: string) {
    return {
      // Add safe, URL encoded parameters and headers
      params: new HttpParams()
        .append('workitemId', workitemId),
      headers: this.headers(sessionId)
    };
  }

  getWorkflowFormOptions(sessionId: string, className: string) {
    return {
      // Add safe, URL encoded parameters and headers
      params: new HttpParams()
        .append('className', className),
      headers: this.headers(sessionId)
    };
  }

}
